import React from 'react';
import PropTypes from 'prop-types';
import { FontIcon } from '../';
import cn from 'classnames';
import './Button.scss';

const Button = ({
  children,
  className,
  disabled = false,
  icon,
  type = 'button',
  href,
  ...props
}) => {

  function getIconClass(icon, children) {
    return icon && !children ? 'icon' : icon && children ? 'with-icon' : '';
  }

  const Component = href ? 'a' : 'button';
  const typeAttr = href ? null : type;

  return (
    <Component
      {...props}
      href={href}
      type={typeAttr}
      role="button"
      className={cn('ph-button', className, getIconClass(icon, children))}
      >
        {icon &&
          <FontIcon>{icon}</FontIcon>
        }
        {children}
    </Component>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  icon: PropTypes.string,
  type: PropTypes.oneOf(['button', 'reset', 'submit', null]),
};

export default Button;
